













































































































import { IRoomControl, IRoom, IRoomPosition } from "@/@types/hotel/room";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IActivityStatus as ITV } from "@/@types/admin/activity-status";
import { IStaff } from "@/@types/admin/staff";

import RoomForm from "@/components/forms/room/room-form.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({ components: { StandartModal, RoomForm } })
export default class HotelConstructor extends Vue {
  @Prop({ type: Array, default: () => [] }) rooms!: Array<IRoom>;
  @Prop({ type: Array, default: () => [] }) types!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) levels!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) statuses!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) tvs!: Array<ITV>;
  @Prop({ type: Array, default: () => [] }) devices!: Array<ITV>;
  @Prop({ type: Array, default: () => [] }) staffs!: Array<IStaff>;
  @Prop({ type: Object, default: null }) el!: IRoom;
  @Prop({ type: Number, default: 0 }) levelID!: number;

  tabIndex = this.levelID;
  x = "";
  y = "";

  DEFAULT_COLS = 50;
  DEFAULT_ROWS = 5;
  COLS_MAX = 200;
  ROWS_MAX = 50;
  cols = this.DEFAULT_COLS;
  rows = this.DEFAULT_ROWS;

  dragRoom: IRoom | null = null;
  dragOrigin: { x: number; y: number } | null = null;
  dropTarget: { x: number; y: number } | null = null;

  get level(): string {
    return this.levels[this.tabIndex] ? this.levels[this.tabIndex]._id : "";
  }

  get roomList(): Array<IRoom> {
    return this.rooms.filter((room) => room.level == this.level);
  }

  get roomMap(): { [key: string]: IRoom } {
    const map: { [key: string]: IRoom } = {};
    this.roomList.forEach((room) => {
      if (room.position && room.position.x != null && room.position.y != null)
        map[`${room.position.x},${room.position.y}`] = room;
    });
    return map;
  }

  roomAt(x: number, y: number): IRoom | undefined {
    return this.roomMap[`${x},${y}`];
  }

  cellName(x: number, y: number): string {
    const room = this.roomAt(x, y);
    return room ? room.name : "ㅤ";
  }

  cellTitle(x: number, y: number): string {
    const room = this.roomAt(x, y);
    return room ? room.name : `x: ${x}, y: ${y}`;
  }

  isFilled(x: number, y: number): boolean {
    return !!this.roomAt(x, y);
  }

  cellClass(x: number, y: number): Array<string> {
    const cls: Array<string> = ["constructor-cell"];
    const room = this.roomAt(x, y);
    if (room) {
      cls.push("constructor-cell--filled");
      if (this.el && room._id === this.el._id)
        cls.push("constructor-cell--selected");
      if (this.dragRoom && room._id === this.dragRoom._id)
        cls.push("constructor-cell--dragging");
      return cls;
    }
    if (this.x === String(x) && this.y === String(y))
      cls.push("constructor-cell--reserved");
    if (this.dropTarget && this.dropTarget.x === x && this.dropTarget.y === y)
      cls.push("constructor-cell--drop");
    return cls;
  }

  /**
   * Авто-подгон размера: дефолт 5x50 либо больше, если комнаты выходят за пределы.
   */
  autoSize(): void {
    let maxX = -1;
    let maxY = -1;
    this.roomList.forEach((room) => {
      if (room.position && room.position.x != null && room.position.y != null) {
        const px = parseInt(room.position.x);
        const py = parseInt(room.position.y);
        if (!isNaN(px) && px > maxX) maxX = px;
        if (!isNaN(py) && py > maxY) maxY = py;
      }
    });
    this.cols = Math.min(this.COLS_MAX, Math.max(this.DEFAULT_COLS, maxX + 1));
    this.rows = Math.min(this.ROWS_MAX, Math.max(this.DEFAULT_ROWS, maxY + 1));
  }

  changeLevel(id: string): void {
    const i = this.levels.findIndex((el) => el._id == id);
    if (i < 0) return;
    this.tabIndex = i;
  }

  /**
   * Клик по ячейке: пустую — резервим под новый номер,
   * занятую — снимаем резерв.
   */
  onCellClick(x: number, y: number): void {
    if (this.isFilled(x, y)) {
      this.x = "";
      this.y = "";
      return;
    }
    this.x = String(x);
    this.y = String(y);
  }

  /* ---------- drag & drop ---------- */

  onDragStart(e: DragEvent, x: number, y: number): void {
    const room = this.roomAt(x, y);
    if (!room) {
      e.preventDefault();
      return;
    }
    this.dragRoom = room;
    this.dragOrigin = { x, y };
    if (e.dataTransfer) {
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setData("text/plain", room._id);
    }
  }

  onDragEnter(x: number, y: number): void {
    if (this.dragRoom) this.dropTarget = { x, y };
  }

  onDragLeave(x: number, y: number): void {
    if (this.dropTarget && this.dropTarget.x === x && this.dropTarget.y === y)
      this.dropTarget = null;
  }

  onDrop(x: number, y: number): void {
    const dragRoom = this.dragRoom;
    const origin = this.dragOrigin;
    this.dragRoom = null;
    this.dragOrigin = null;
    this.dropTarget = null;
    if (!dragRoom || !origin) return;
    if (origin.x === x && origin.y === y) return; // drop на ту же ячейку

    const target = this.roomAt(x, y);
    if (target && target._id === dragRoom._id) return;

    // Переносим комнату на новую ячейку.
    this.$emit("reposition", dragRoom, x, y);
    // Если ячейка занята — меняем комнаты местами.
    if (target) this.$emit("reposition", target, origin.x, origin.y);
  }

  onDragEnd(): void {
    this.dragRoom = null;
    this.dragOrigin = null;
    this.dropTarget = null;
  }

  changeRoom(data: Partial<IRoom>): void {
    const position: IRoomPosition = {
      x: this.x,
      y: this.y,
      z: this.level,
    };
    data.position = position;
    const id = this.el ? this.el._id : "";
    this.$emit("change", data, id);
    if (id) this.$bvModal.hide("constructor");
  }

  @Watch("levelID")
  updateTabInx(): void {
    this.tabIndex = this.levelID;
  }

  @Watch("tabIndex")
  updatePlan(): void {
    this.x = "";
    this.y = "";
    this.autoSize();
    this.$emit("updateTabInx", this.tabIndex);
  }

  @Watch("cols")
  onColsChange(v: number): void {
    if (typeof v !== "number" || isNaN(v)) return;
    if (v < 1) this.cols = 1;
    else if (v > this.COLS_MAX) this.cols = this.COLS_MAX;
  }

  @Watch("rows")
  onRowsChange(v: number): void {
    if (typeof v !== "number" || isNaN(v)) return;
    if (v < 1) this.rows = 1;
    else if (v > this.ROWS_MAX) this.rows = this.ROWS_MAX;
  }

  clampCols(): void {
    const v = this.cols;
    if (typeof v !== "number" || isNaN(v) || v < 1)
      this.cols = this.DEFAULT_COLS;
    else if (v > this.COLS_MAX) this.cols = this.COLS_MAX;
  }

  clampRows(): void {
    const v = this.rows;
    if (typeof v !== "number" || isNaN(v) || v < 1)
      this.rows = this.DEFAULT_ROWS;
    else if (v > this.ROWS_MAX) this.rows = this.ROWS_MAX;
  }

  @Watch("el")
  onElChange(): void {
    if (this.el && this.el.position) {
      this.x = String(this.el.position.x);
      this.y = String(this.el.position.y);
      const z = this.levels.findIndex((l) => l._id == this.el.level);
      if (z >= 0) this.tabIndex = z;
    } else {
      this.x = "";
      this.y = "";
    }
  }

  mounted(): void {
    this.$nextTick(() => {
      this.autoSize();
      if (this.el && this.el.position) {
        this.x = String(this.el.position.x);
        this.y = String(this.el.position.y);
        const z = this.levels.findIndex((el) => el._id == this.el.level);
        if (z >= 0) this.tabIndex = z;
      }
    });
  }

  beforeDestroy(): void {
    this.x = "";
    this.y = "";
  }
}
